import { useCallback, useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

// Read-only executive price overview aggregated per location.
const usePriceOverview = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getPriceOverview = useCallback(async () => {
    return await sendRequest({
      url: '/api/v1/product/price-overview',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  }, [authCtx, sendRequest]);

  return { isLoading, error, getPriceOverview };
};

export default usePriceOverview;
